import { get, postJSON, post } from "./request";


// 登录
export const login = data => post("login", data);



// WEBPACK FOOTER //
// ./src/assets/api/login.js